"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeAnswers = normalizeAnswers;
exports.validateAnswers = validateAnswers;
exports.buildTemplateContext = buildTemplateContext;
const question_registry_1 = require("./question-registry");
const template_manifest_1 = require("./template-manifest");
function normalizeAnswers(input) {
    const out = {};
    for (const q of question_registry_1.QUESTION_REGISTRY) {
        let v = input[q.id];
        if (v == null && q.default != null)
            v = q.default;
        if (q.type === 'number' && v != null)
            v = Number(v);
        if (q.type === 'boolean')
            v = !!v;
        out[q.id] = v;
    }
    return out;
}
function validateAnswers(answers) {
    const errs = [];
    for (const q of question_registry_1.QUESTION_REGISTRY) {
        if (q.visibleIf && !q.visibleIf(answers))
            continue;
        const value = answers[q.id];
        if (q.required && (value === null || value === '' || value === undefined)) {
            errs.push(`${q.label} is required`);
            continue;
        }
        if (q.validate) {
            const e = q.validate(value, answers);
            if (e)
                errs.push(e);
        }
    }
    return errs;
}
function computeDerived(answers) {
    const names = [];
    if (answers['officerPresident'])
        names.push('President');
    if (answers['officerVicePresident'])
        names.push('Vice-President');
    if (answers['officerTreasurer'])
        names.push('Treasurer');
    if (answers['officerViceTreasurer'])
        names.push('Vice-Treasurer');
    if (answers['officerSecretary'])
        names.push('Secretary');
    if (answers['officerMemberAtLarge'])
        names.push('Member-at-Large');
    if (answers['officerCommunications'])
        names.push('Communications Coordinator');
    if (answers['officerVolunteerCoordinator'])
        names.push('Volunteer Coordinator');
    const quorumMode = answers['quorumExecMode'];
    const quorumNumber = answers['quorumExecNumber'];
    let quorumExecSummary = null;
    if (quorumMode === 'Specific number' && typeof quorumNumber === 'number') {
        quorumExecSummary = `${quorumNumber} board members present and voting`;
    }
    else if (typeof quorumMode === 'string' && quorumMode.trim()) {
        quorumExecSummary = quorumMode.trim();
    }
    const signersMode = answers['checkSignersMode'];
    let checkSignersSummary = null;
    if (signersMode === 'noRequirement') {
        checkSignersSummary =
            'A second signature is optional based on board policy but at least one authorized signer must approve each disbursement.';
    }
    else {
        checkSignersSummary =
            'Two signatures are required on all disbursements whenever practicable.';
    }
    return {
        officers: names.join(', '),
        quorumExecSummary,
        checkSignersSummary,
    };
}
function toTrimmedString(value) {
    if (value == null) {
        return undefined;
    }
    const str = String(value).trim();
    return str ? str : undefined;
}
function buildConflictOfInterestDerivedFields(answers) {
    const appliesTo = answers['conflictAppliesTo'];
    const recordkeeping = answers['conflictRecordkeeping'];
    const orgName = toTrimmedString(answers.orgName) ?? 'the organization';
    let conflictApplicabilitySentence;
    switch (appliesTo) {
        case 'Board and officers only':
            conflictApplicabilitySentence = `This policy applies to the Executive Board and elected officers of ${orgName}.`;
            break;
        case 'Board, officers, and key volunteers':
        default:
            conflictApplicabilitySentence = `This policy applies to the Executive Board, elected officers, and other volunteers or committee members acting in an official capacity for ${orgName}.`;
            break;
    }
    let conflictRecordkeepingSummary;
    switch (recordkeeping) {
        case 'Minimal (note conflicts in the minutes)':
            conflictRecordkeepingSummary =
                'The organization notes conflicts of interest and any recusals in the meeting minutes.';
            break;
        case 'Standard (keep a simple log of disclosures)':
        default:
            conflictRecordkeepingSummary =
                'The organization keeps a simple record of conflict-of-interest disclosures, related discussions, and any recusals, and reflects them in the meeting minutes.';
            break;
    }
    return {
        conflictApplicabilitySentence,
        conflictRecordkeepingSummary,
    };
}
function buildTemplateContext(raw) {
    const answers = normalizeAnswers(raw);
    const computed = {
        ...computeDerived(answers),
        ...buildConflictOfInterestDerivedFields(answers),
    };
    const ctx = {};
    for (const v of template_manifest_1.TEMPLATE_VARS) {
        if (v.source === 'answer') {
            ctx[v.name] = answers[v.from] ?? v.default ?? null;
        }
        else if (v.source === 'computed') {
            ctx[v.name] =
                computed[v.from] ?? v.default ?? null;
        }
        else {
            ctx[v.name] = v.default ?? null;
        }
    }
    return ctx;
}
